import { Observable } from 'rxjs';
import { Inputfiledsbase } from '../../../../../../inputfileds/models/inputfiledsbase';
import { Component, Inject } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute } from '@angular/router';
import { QuestionControlService } from '../../../../../../inputfileds/form_services/question-control.service';
import { WebComponentsNameService } from '../../../../../../inputfileds/form_services/websitemanagementService02/webSitesName/pageName/webComponentsName/web-components-name.service';
import { ApiservicesService } from '../../../../../../Services/Apis/apiservices.service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { DynamicFormQuestionComponent } from '../../../../../../inputfileds/dynamic-form-question/dynamic-form-question.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateDirective } from '../../../../../../components/Utilites/Directives/translate.directive';
import { TranslatePipe } from '../../../../../../components/Utilites/Pipe/translate.pipe';

interface WebsiteComponent {
  id: number;
  model_id: number;
  component_id: number;
  name: string;
  model_name: string;
  image_url?: string;
  status?: string;
  website_id?: number;
  website_page_id?: number;
}

interface AddComponentDialogData {
  websiteId: string | number;
  pageId: string | number;
  componentId?: string | number;
  id?: string | number;
  // any other fields that might be patched into the form
  [key: string]: any;
}

@Component({
  selector: 'app-add-component-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    DynamicFormQuestionComponent,
    MatDividerModule,
    MatIconModule,
    MatCardModule,
    MatProgressSpinnerModule,
    TranslateDirective,
    TranslatePipe,
  ],
  templateUrl: './add-component-dialog.component.html',
  styleUrl: './add-component-dialog.component.scss',
  providers: [QuestionControlService, WebComponentsNameService],
})
export class AddComponentDialogComponent {
  componentsList: WebsiteComponent[] = [];
  fromcontrols: Inputfiledsbase<any>[] = [];
  form!: FormGroup;

  selectedComponent: WebsiteComponent | null | undefined = null;
  isLoading = false;
  isSubmitting = false;
  componentsLoading = false;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<AddComponentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AddComponentDialogData,
    private componentNameQuestion: WebComponentsNameService,
    private questionServices: QuestionControlService,
    private _route: ActivatedRoute,
    private apiServices: ApiservicesService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadComponents();
  }
  initForm(): void {
    const handleQuestions = (questions: Inputfiledsbase<any>[]) => {
      this.fromcontrols = questions;
      this.form =
        this.questionServices.toFormGroup(this.fromcontrols) ||
        this.fb.group(
          this.fromcontrols.reduce(
            (acc, q) => {
              acc[q.key] = [
                q.value || '',
                q.required ? [Validators.required] : [],
              ];
              return acc;
            },
            {} as { [key: string]: any },
          ),
        );

      if (this.data) {
        this.form.patchValue(this.data);
      }
    };

    const result = this.componentNameQuestion.getComponentNameform();

    if (Array.isArray(result)) {
      handleQuestions(result);
    } else if (result) {
      this.isLoading = true;
      (result as Observable<Inputfiledsbase<any>[]>).subscribe({
        next: handleQuestions,
        error: (err) => {
          console.error('Failed to load form questions', err);
          this.snackBar.open('Failed to load form configuration', 'Close', {
            duration: 3000,
          });
          this.isLoading = false;
        },
        complete: () => (this.isLoading = false),
      });
    } else {
      console.error(
        'Unexpected return type from getComponentNameform()',
        result,
      );
    }
  }

  loadComponents(): void {
    this.componentsLoading = true;
    this.apiServices.getComponentlist().subscribe({
      next: (res) => {
        this.componentsList = res?.rows || [];
        if (this.data?.['model_id']) {
          this.selectedComponent =
            this.componentsList.find(
              (c) => c.model_id === this.data?.['model_id'],
            ) ?? null;
        }
      },
      error: (err) => {
        console.error('Error loading components:', err);
        this.snackBar.open('Failed to load components', 'Close', {
          duration: 3000,
        });
        this.componentsLoading = false;
      },
      complete: () => (this.componentsLoading = false),
    });
  }

  selectComponent(comp: WebsiteComponent): void {
    this.selectedComponent = comp;
  }

  getImageUrl(path: any): string {
    return path
      ? `${this.apiServices.environmentPath}/${path}`
      : 'assets/placeholder.png';
  }

  onImageError(event: Event): void {
    const img = event.target as HTMLImageElement;
    img.src = 'assets/placeholder.png';
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    if (this.isSubmitting) return;

    // Validate selection
    if (!this.selectedComponent) {
      this.snackBar.open('Please select a component first', 'Close', {
        duration: 3000,
      });
      return;
    }

    // Validate form
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      this.snackBar.open('Please fill all required fields', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.isSubmitting = true;

    const formData = {
      ...this.form.value,
      component_id: this.selectedComponent.id,
      website_id: this.data?.websiteId,
      website_page_id: this.data?.pageId,
      id: this.data?.id,
    };

    this.dialogRef.close(formData);
  }
}
